export const RU_MESSAGES = {
  'form.validation.required': 'Заполните это поле',
  'form.validation.email': 'Введите корректный email',
  'form.validation.phone': 'Введите корректный номер телефона',
  'form.validation.pattern': 'Значение не соответствует формату',
  'form.validation.minLength': 'Минимальная длина: {count}',
  'form.validation.maxLength': 'Максимальная длина: {count}',
  'form.validation.consent': 'Подтвердите согласие',
  'form.validation.selectOption': 'Выберите вариант',
  'form.defaultSuccess': 'Спасибо! Мы свяжемся с вами.',
  'form.defaultError': 'Что-то пошло не так. Попробуйте ещё раз.',
  'form.sending': 'Отправляем…',
  'form.editModeDisabled': 'В режиме редактирования отправка отключена',
  'form.successTitle': 'Заявка отправлена',
  'form.successButton': 'Готово',
  'countdown.dayShort': 'д',
  'countdown.expired': 'Время истекло',
  'copy.success': 'Скопировано',
  'video.play': 'Воспроизвести видео',
  'video.frameTitle': 'Видео',
  'slider.previous': 'Предыдущий слайд',
  'slider.next': 'Следующий слайд',
  'lightbox.previous': 'Предыдущее изображение',
  'lightbox.next': 'Следующее изображение',
  'lightbox.close': 'Закрыть',
  'map.loading': 'Загрузка карты…',
  'map.loadError': 'Не удалось загрузить карту',
} as const;

export type MessageKey = keyof typeof RU_MESSAGES;
export type LocaleMessages = Record<MessageKey, string>;
export type MessageParams = Record<string, string | number>;
